import { Component, Input, OnInit } from "@angular/core";
import { ControlContainer, FormControl } from "@angular/forms";
import { CampoSpecificoFascicolazioneDTO } from "@app/shared/dto/campo-specifico-fascicolazioneDTO";
import { SiNoEnum } from "@app/shared/enum/si-no-enum";
import { TipoAnagraficaCampoSpecificoEnum } from "@app/shared/enum/tipo-anagrafica-campo-specifico-enum";
import { TipoCampoSpecificoEnum } from "@app/shared/enum/tipo-campo-specifico-enum";
import { TipoFormEnum } from "@app/shared/enum/tipo-form.enum";
import { AppUtilityHelper } from "@app/shared/helper/app-utility.helper";
import { FascicoloHelper } from "@app/shared/helper/fascicolo.helper";
import { CampoSpecificoFascicolazioneVO } from "@app/shared/vo/campo-specifico-fascicolazioneVO";
import { SoggettoRicercaVO } from "@app/shared/vo/soggetto-ricercaVO";
import { ValoreCampoVO } from "@app/shared/vo/valori-campoVO";

@Component({
  selector: "app-valori-campo-specifico",
  templateUrl: "./valori-campo-specifico.component.html",
})
export class ValoriCampoSpecificoComponent implements OnInit {
  valoriFormArray;
  @Input()
  campo: CampoSpecificoFascicolazioneVO;
  @Input()
  tipoForm: TipoFormEnum;
  FascicoloHelper = FascicoloHelper;
  TipoAnagraficaCampoSpecificoEnum = TipoAnagraficaCampoSpecificoEnum;
  SiNoEnum = SiNoEnum;
  constructor(private parentControl: ControlContainer) {}

  ngOnInit() {
    this.valoriFormArray = this.parentControl.control;
  
  }

  valorizza(valoreDigitato: any) {
  
   const length = this.valoriFormArray.controls.length;
    let esisteGia: boolean;
    if (valoreDigitato instanceof SoggettoRicercaVO) {
      esisteGia = this.valoriFormArray.value.filter(
        (valoreFilter) => valoreFilter != null && 
        ((valoreFilter.codiceFiscale != null && valoreFilter.codiceFiscale === valoreDigitato.codiceFiscale) ||
        valoreFilter.denominazione != null && valoreFilter.denominazione === valoreDigitato.denominazione)

      ).length > 0;
    } else {
      if (this.campo.tipoDato === "DATA") {
          esisteGia = this.valoriFormArray.value.filter(
          (valoreFilter) => valoreFilter != null && valoreFilter === new Date(valoreDigitato).toISOString()
        ).length > 0;
      } else {
      esisteGia = this.valoriFormArray.value.filter(
        (valoreFilter) => valoreFilter != null && valoreFilter === valoreDigitato
      ).length > 0;
    }
  }
   
    if (!esisteGia) {
      if (this.campo.tipoDato === "DATA") {
        this.valoriFormArray.controls[length - 1].setValue(new Date(valoreDigitato).toISOString());
      } else {
        this.valoriFormArray.controls[length - 1].setValue(valoreDigitato);
      }
     } else if (!this.isAnagraficaLibera()) {
      this.valoriFormArray.removeAt(length - 1);
      this.valoriFormArray.insert(length - 1, new FormControl());
     } else {
      this.valoriFormArray.controls[length - 1].setValue(valoreDigitato);
     }
  }

  aggiungiNuovoValore() {
  
    const length = this.valoriFormArray.controls.length;
    const esisteGia = this.valoriFormArray.value.filter(
      (valoreFilter, index) => (index !== length - 1) && valoreFilter != null && valoreFilter === this.valoriFormArray.value[length - 1]
    ).length > 0;
   
  if (esisteGia && this.isAnagraficaLibera() && length > 1 ) {
    this.valoriFormArray.removeAt(length - 1);
    this.valoriFormArray.insert(length, new FormControl());
   } else {
    this.valoriFormArray.insert(length, new FormControl());
   }
  }

  setPipe(valore: string, tipoDato: string) : ValoreCampoVO{
    const valoreCampo =  new ValoreCampoVO();
    valoreCampo.valore = valore;
     if (tipoDato === "DATA") {
      valoreCampo.valorePipe =   valoreCampo.valorePipe = new Date(valore).toLocaleDateString();
     } else {
      valoreCampo.valorePipe =   valoreCampo.valore;
     }
     return valoreCampo;
  }

  
  rimuovi(i: number) {
    this.valoriFormArray.removeAt(i);
    if (this.valoriFormArray.controls.length === i) {
      this.valoriFormArray.insert(i, new FormControl());
    }

  }

  isAnagraficaEsterna(): boolean{
    return (FascicoloHelper.getTipoAnagraficaCampo(this.campo) != null &&
     Object.values(TipoAnagraficaCampoSpecificoEnum).includes(FascicoloHelper.getTipoAnagraficaCampo(this.campo)));
  }

  isAnagraficaManuale(): boolean{
    return (FascicoloHelper.getTipoAnagraficaCampo(this.campo) != null && 
    !Object.values(TipoAnagraficaCampoSpecificoEnum).includes(FascicoloHelper.getTipoAnagraficaCampo(this.campo)));
  }

  isAnagraficaLibera(): boolean{
    return (FascicoloHelper.getTipoAnagraficaCampo(this.campo) == null);
  }
 
}
